import { SITE } from "../lib/site";
import BeforeAfterCompare from "./BeforeAfterCompare";

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-28 lg:py-36 bg-black"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 mb-14 reveal">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-8 bg-gold" />
              <span className="text-xs uppercase tracking-[0.32em] text-gold/90">
                Before &amp; After
              </span>
            </div>
            <h2 className="font-display font-light text-5xl lg:text-6xl tracking-tight max-w-2xl leading-[1.02]">
              Real cars.
              <span className="italic gold-shimmer"> Real transformations</span>.
            </h2>
          </div>
          <p className="lg:max-w-sm text-white/55 leading-relaxed">
            Drag the gold handle on each photo to slide between the before and
            after. These are actual cars we&apos;ve detailed in North Seattle.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-8 reveal">
          {SITE.beforeAfter.map((b, i) => (
            <BeforeAfterCompare
              key={i}
              testid={`ba-${i}`}
              beforeSrc={b.before}
              afterSrc={b.after}
              caption={b.caption}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
